import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortComponent } from './port.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PortComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ]
})
export class PortModule { }
